<template>
    <div class="card-container">
        <common-top-form :model="formModel" @success="onSuccess"
                         :submitService="submitService" :submitData="submitData" :showDownloadPower="true"
                         buttonName="配置" @openAddDialog="openAddDialog" @upload="handleStatistic(1)"
                         showDownloadPowerType="purple" uploadPowerType="purple" downloadPowerText="合计"
                         uploadPowerText="统计分析" downloadPower="/statistics/tatAssets" @down="handleStatistic(2)"
                         uploadPower="/statistics/tatAssets">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <el-form-item label="订单类型">
                <el-select v-model="formModel.orderType">
                    <el-option
                        v-for="item in businessType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易类型" v-if="tranTypes.length">
                <el-select v-model="formModel.tranType">
                    <el-option
                        v-for="item in tranTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构名称" min-width="100" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="orderNo" label="订单编号" min-width="130" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="amount" label="交易金额" :formatter="formatterTableNumber" min-width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="fee" label="分润金额" :formatter="formatterTableNumber" min-width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderType" label="订单类型" :formatter="formatOrderType" min-width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="serviceType" label="交易类型" :formatter="formatServiceType" min-width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="操作时间" min-width="160" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
        </common-table>
        <show-info-dialog :title="dialogTitle" :show="true" ref="showInfoDialog"
                          :dialogWidth="dialogType == 1 ? '1000px' : '400px'" class="showInfoDialog">
            <div v-if="this.dialogType == 1">
                <common-top-form :model="dialogModel" @success="dialogSuccess" :submitService="dialogService"
                                 :submitData="dialogData" :show="false">
                    <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId"></select-organs>
                    <el-form-item label="日期">
                        <el-date-picker
                            v-model="dialogModel.time"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </common-top-form>
                <common-table :data="dialogTableData" ref="commonTable" :isShow="false">
                    <el-table-column prop="orderTypeName" label="类型" min-width="100" show-overflow-tooltip
                                     :formatter="formatterTableData"></el-table-column>
                    <el-table-column prop="rate" label="概率%" min-width="130" show-overflow-tooltip
                                     :formatter="formatterTableData"></el-table-column>
                    <el-table-column prop="proportion" label="比例%" :formatter="formatterTableData" min-width="100"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="fee" label="实际收益（元）" :formatter="formatterTableNumberYuan" min-width="100"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="taxFee" label="扣税（元）" :formatter="formatterTableNumberYuan" min-width="100"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="allFee" label="总收益（元）" :formatter="formatterTableNumberYuan" min-width="100"
                                     show-overflow-tooltip></el-table-column>
                </common-table>
            </div>
            <div v-else>
                <p>总笔数：{{countInfo.count}}笔</p>
                <p>总金额：{{toDoubleThousands(countInfo.amount)}}元</p>
                <p>总利润：{{toDoubleThousands(countInfo.profit)}}元</p>
            </div>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import TimeRange from 'service/constant/TimeRange'
    import ShowInfoDialog from '../../dialog/ShowInfoDialog'
    import FinanceService from 'service/FinanceService'
    import BusinessType from 'service/constant/BusinessType'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "taxlog",
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    orderType: '',
                    tranType: '',
                    time: TimeRange.dayRange,
                },
                dialogModel: {
                    time: TimeRange.dayRange,
                    tatSimpleId: '',
                },
                tableData: [],
                dialogTableData: [],
                tranTypes: [],
                submitService: FinanceService.tatTaxLogList,
                dialogService: FinanceService.tatTaxLog,
                page: [],
                isPage: false,
                countInfo: {},
                businessType: BusinessType,
                dialogTitle: '',
                dialogType: 1,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components: {
            CommonTopForm,
            CommonTable,
            SelectOrgans,
            ShowInfoDialog
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.roleYuan.indexOf(vm.userInfo.userName) < 0) {
                    vm.showWarming('您暂无该权限');
                    vm.$router.back(-1);
                }
            })
        },
        watch: {
            'formModel.orderType'(val, oldVal) {
                this.formModel.tranType = '';
                if (!val) {
                    this.tranTypes = [];
                    return
                }
                this.businessType.find(item => {
                    if (item.dictKey == val) {
                        this.tranTypes = item.flag;
                    }
                })
            },
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    orderType: this.formModel.orderType,
                    serviceType: this.formModel.tranType,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time != null && this.formModel.time.length) {
                    params.createDateStart = this.formModel.time[0];
                    params.createDateEnd = this.formModel.time[1];
                }
                return params;
            },
            dialogData() {
                if (this.dialogModel.time == null || this.dialogModel.time == '') {
                    this.dialogModel.time = [];
                }
                const params = {
                    tatSimpleId: this.dialogModel.tatSimpleId,
                };

                if (this.dialogModel.time != null && this.dialogModel.time.length) {
                    params.startDate = this.dialogModel.time[0];
                    params.endDate = this.dialogModel.time[1];
                }
                return params;

            },
            ...mapGetters(['serverType', 'tatId', 'userId', 'userInfo']),
        },
        methods: {
            getPage() {
                this.isPage = true;
                this.getList();
            },
            formatOrderType(row, column, cellValue) {
                let value = '';
                this.businessType.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : '--';
            },
            formatServiceType(row, column, cellValue) {
                let value = '--';
                const types = this.businessType.find(item => item.dictKey == row.orderType);
                if (types.flag) {
                    types.flag.forEach(item => {
                        if (item.dictKey == cellValue) {
                            value = item.dictValue;
                        }
                    })
                }
                return value;
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                const result = data.contents;
                this.tableData = result.records;
                this.page.currentPage = result.current;
                this.page.total = result.total;
                this.page.pageSize = result.size;
            },
            dialogSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.dialogTableData = result ? result : [];
                })
            },
            handleStatistic(type) {
                this.dialogModel = {
                    time: TimeRange.dayRange,
                    tatSimpleId: '',
                };
                this.dialogTableData = [];
                this.dialogType = type;
                this.dialogTitle = this.dialogType == 1 ? '统计分析' : '合计';
                if (this.dialogType == 1) {
                    this.$refs.showInfoDialog.open();
                    return
                }
                this.getCount();

            },
            getCount() {
                this.doLoad(FinanceService.tatTaxLogAdd, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        if (result) {
                            this.countInfo = result;
                        }
                        this.$nextTick(() => {
                            this.$refs.showInfoDialog.open();
                        })
                    });
                }, '信息获取失败')
            },
            openAddDialog() {
                this.$router.push({
                    name: 'taxlogconfig'
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/TaxLog.vue